import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Tabs from "components/lib/Shared/Tabs";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import SingleStep from "./SingleStep";

const ESignatureTab = ({ handleBackBtn }) => {
  const { company } = useSelector((state) => state.companySlice);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isDirectorsOnlyFormsUploaded, setIsDirectorsOnlyFormsUploaded] =
    useState(false);
  const [isShareholdersOnlyFormsUploaded, setIsShareholdersOnlyFormsUploaded] =
    useState(false);
  const [isFirstStepComplete, setIsFirstStepComplete] = useState(false);
  const [shareholders, setShareholders] = useState([]);
  const [directors, setDirectors] = useState([]);
  const [isAllDirectorsShareholders, setIsAllDirectorsShareholders] =
    useState(false);

  const companyOfficials = useSelector(
    (state) => state.companyOfficialsSlice.companyOfficials.items
  );

  const tabs = [
    {
      id: "directorsOnlyForm",
      label: "Directors Only Forms",
    },
    {
      id: "shareholdersOnlyForm",
      label: "Shareholders Only Forms",
    },
  ];

  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  useEffect(() => {
    const officialShareHolders = companyOfficials.filter(
      (official) =>
        official.designation === "Shareholder" ||
        official.designation === "Director Shareholder" ||
        official.designation === "Joint Shareholder"
    );
    setShareholders(officialShareHolders);

    const officialDirectors = companyOfficials.filter(
      (official) =>
        official.designation === "Director" ||
        official.designation === "Director Shareholder" ||
        official.designation === "Company Secretary"
    );
    setDirectors(officialDirectors);

    const isAllOfficialsADirectorsShareholders = !companyOfficials.find(
      (official) =>
        official?.designation === "Shareholder" ||
        official?.designation === "Joint Shareholder" ||
        official.designation === "Director Shareholder"
    );
    setIsAllDirectorsShareholders(isAllOfficialsADirectorsShareholders);
  }, []);

  const completeFirstStep = () => {
    setIsFirstStepComplete(true);
  };

  if (isAllDirectorsShareholders) {
    return <SingleStep handleBackBtn={handleBackBtn} />;
  } else {
    return (
      <div>
        <Tabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          showTooltip
        />

        {selectedTab.id === "directorsOnlyForm" && (
          <FirstStep
            isDirectorsOnlyFormsUploaded={isDirectorsOnlyFormsUploaded}
            setIsDirectorsOnlyFormsUploaded={setIsDirectorsOnlyFormsUploaded}
            setSelectedTabIndex={setSelectedTabIndex}
            selectedTabIndex={selectedTabIndex}
            completeFirstStep={completeFirstStep}
            directors={directors}
          />
        )}
        {selectedTab.id === "shareholdersOnlyForm" && (
          <SecondStep
            handleBackBtn={handleBackBtn}
            isShareholdersOnlyFormsUploaded={isShareholdersOnlyFormsUploaded}
            setIsShareholdersOnlyFormsUploaded={
              setIsShareholdersOnlyFormsUploaded
            }
            isFirstStepComplete={isFirstStepComplete}
            shareholders={shareholders}
          />
        )}
      </div>
    );
  }
};

export default ESignatureTab;
